import { Button } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { Slot } from '../hooks/useGetConsumerSchedulingProfileSlotsQuery';

interface Props {
  disabled: boolean;
  onClick: () => void;
  slot?: Slot;
}

const Styles = styled.div`
  .more-slots-button {
    background-color: ${({ theme }) => theme.blueDarkest} !important;
    background-size: cover;
    color: ${({ theme }) => theme.white} !important;
    border-color: ${({ theme }) => theme.blueDarkest} !important;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
    font-family: Source Sans Pro, sans-serif;
    font-size: 14px;
    height: 38px;
    margin-bottom: 4px;
    margin-top: 4px;
    text-align: center;
    text-decoration: none solid;
    text-transform: uppercase;
    width: 80px;

    &:hover,
    &:focus {
      background-color: ${({ theme }) => theme.primaryColor} !important;
      border-color: ${({ theme }) => theme.primaryColor} !important;
      color: ${({ theme }) => theme.white} !important;
    }
  }
`;

export const MoreSlotsButton: FC<Props> = ({ disabled, onClick }): JSX.Element => (
  <Styles>
    <Button className="more-slots-button" disabled={disabled} onClick={() => onClick()}>
      More
    </Button>
  </Styles>
);
